import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { IModalSettings } from 'app/domains/shared/components/modal/modal.component';
import { EnumPreferencesSection } from 'app/domains/aya/enums/preferences-section.enum';
import { PreferencesModalService } from 'app/domains/aya/services/preferences-modal.service';

interface IPreferencesNavItem {
  section: EnumPreferencesSection;
  label: string;
}

@Component({
  selector: 'sgt-preferences-modal',
  templateUrl: './preferences-modal.component.html',
  styleUrls: ['./preferences-modal.component.scss'],
})
export class PreferencesModalComponent implements OnInit, OnDestroy {
  readonly modalSettings: IModalSettings = {
    width: '960px',
    hasHeader: false,
    hasFooter: false,
    showCloseButton: false,
    allowClickOutsideToClose: true,
    allowEscapeToClose: true,
    customClass: 'preferences-modal-host',
  };

  readonly sections = EnumPreferencesSection;

  readonly navItems: IPreferencesNavItem[] = [
    { section: EnumPreferencesSection.Geral, label: 'Geral' },
    { section: EnumPreferencesSection.Conhecimento, label: 'Conhecimento' },
    { section: EnumPreferencesSection.Memorias, label: 'Memórias' },
    { section: EnumPreferencesSection.Habilidades, label: 'Habilidades' },
    { section: EnumPreferencesSection.Automacoes, label: 'Automações' },
    { section: EnumPreferencesSection.Conectores, label: 'Conectores' },
    { section: EnumPreferencesSection.Plugin, label: 'Plugin' },
  ];

  isOpen = false;
  activeSection = EnumPreferencesSection.Geral;

  @ViewChild('content') private content?: ElementRef<HTMLElement>;

  private destroy$ = new Subject<void>();

  constructor(private preferencesModalService: PreferencesModalService) {}

  ngOnInit(): void {
    this.preferencesModalService
      .getIsOpen$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(isOpen => (this.isOpen = isOpen));

    this.preferencesModalService
      .getActiveSection$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(section => {
        this.activeSection = section;
        this.resetContentScroll();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectSection(section: EnumPreferencesSection): void {
    this.preferencesModalService.setActiveSection(section);
  }

  onClose(): void {
    this.preferencesModalService.closeAndReset();
  }

  private resetContentScroll(): void {
    if (this.content) {
      this.content.nativeElement.scrollTop = 0;
    }
  }
}
